import { MARK } from "../helper";

export abstract class TrackEmptyState {
  static measure() {
    if (this.getCount() > 0) {
      performance.measure(MARK.EMPTY_STATE_TIME, MARK.EMPTY_STATE_TIME_START);
    }
  }

  static getCount(): number {
    return performance.getEntriesByName(MARK.EMPTY_STATE_TIME_START).length;
  }

  static mark() {
    performance.mark(MARK.EMPTY_STATE_TIME_START);
  }

  static getTotalTime(): number {
    this.measure();
    const perfEntries: PerformanceEntryList = performance.getEntriesByName(MARK.EMPTY_STATE_TIME);
    return Math.round(
      perfEntries
        .map((e) => e.duration)
        .reduce((prev: number, current: number): number => {
          return prev + current;
        }, 0)
    );
  }
}

export const trackEmptyState = {
  measure: TrackEmptyState.measure,
  getCount: TrackEmptyState.getCount,
  mark: TrackEmptyState.mark,
  getTotalTime: TrackEmptyState.getTotalTime,
};
